import { createFileRoute } from '@tanstack/react-router'
import { SignInPage } from '@pa/staff'
import { z } from 'zod'

const search = z.object({
  redirect: z.string().optional().catch(undefined),
  reason: z.string().optional().catch(undefined),
})

/** A-01 (Frontend §5.2). */
export const Route = createFileRoute('/sign-in')({
  validateSearch: search,
  component: function SignInRoute() {
    const { redirect, reason } = Route.useSearch()
    return <SignInPage siteName="PF Appointments · Super admin" redirect={redirect} reason={reason} />
  },
})
